import {
  CarouselSection,
  PatternLayer,
  CarouselContainer,
  SlideGrid,
  SlideTitle,
  SlideDescription,
  ImageCard,
  ArrowLeft,
  ArrowRight,
  CarouselTrack,
  CarouselDots,
  Dot,
} from "./HeroCarousel.styles";

import { slides } from "../../data/heroData";

import { FiChevronLeft } from "react-icons/fi";
import { FiChevronRight } from "react-icons/fi";
import { useEffect, useState } from "react";
import PlaybackButton from "../PlaybackButton";

const AUTO_PLAY_TIME = 5000;

const HeroCarousel = ({ id }) => {
  const [slideNo, setSlideNo] = useState(0);


  const [isPaused, setIsPaused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isPaused || isHovered) return;
    const interval = setInterval(() => {
      setSlideNo((prev) => (prev + 1) % slides.length);
    }, AUTO_PLAY_TIME);
    return () => clearInterval(interval);
  }, [isPaused, isHovered, slideNo]);

  const slideChange = (direction = "next") => {
    setSlideNo((prev) =>
      direction === "next"
        ? (prev + 1) % slides.length
        : (prev - 1 + slides.length) % slides.length,
    );
  };

  return (
    <CarouselSection
      id={id}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocusCapture={() => setIsPaused(true)}
      tabIndex={id ? -1 : undefined}
      style={{ scrollMarginTop: "clamp(180px, 14vw, 250px)" }}
    >
      <PatternLayer />

      <ArrowLeft data-print-hide type="button" aria-label="Previous slide" onClick={() => slideChange("prev")}>
        <FiChevronLeft size={70} className="text-[#173f86]" />
        <span className="sr-only">Previous slide</span>
      </ArrowLeft>

      <ArrowRight data-print-hide type="button" aria-label="Next slide" onClick={() => slideChange("next")}>
        <FiChevronRight className="text-[#173f86]" size={70} />
        <span className="sr-only">Next slide</span>
      </ArrowRight>

      <CarouselContainer>
        <CarouselTrack $slideNo={slideNo}>
          {slides.map((slide, index) => (
            <SlideGrid key={index} data-print-slide={index === slideNo ? "active" : "inactive"}
              aria-hidden={index !== slideNo ? true : undefined}
              inert={index !== slideNo ? true : undefined}
              tabIndex={index !== slideNo ? -1 : undefined}>
              <div>
                <SlideTitle>{slide.title}</SlideTitle>
                <SlideDescription>{slide.description}</SlideDescription>
              </div>

              <ImageCard>
                <img
                  src={slide.image}
                  alt={slide.title}
                  width={slide.imageWidth}
                  height={slide.imageHeight}
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                  style={{
                    display: "block",
                    width: "100%",
                    height: "auto",
                    border: "none",
                    borderRadius: 0,
                    outline: "none",
                    boxShadow: "none",
                  }}
                />
              </ImageCard>
            </SlideGrid>
          ))}
        </CarouselTrack>
      </CarouselContainer>
      <CarouselDots data-print-hide>
        {slides.map((_, index) => (
          <Dot
            key={index}
            active={slideNo === index}
            type="button"
            aria-label={`Go to slide ${index + 1}`}
            aria-current={slideNo === index ? "true" : undefined}
            onClick={() => {
              setSlideNo(index);
            }}
          >
            <span className="sr-only">Go to slide {index + 1}</span>
          </Dot>
        ))}
        <PlaybackButton paused={isPaused} onClick={() => setIsPaused((prev) => !prev)}
          label="hero slideshow" style={{ position: "absolute", left: "calc(100% + 10px)", top: "50%", transform: "translateY(-50%)", width: 24, height: 24 }} />
      </CarouselDots>
    </CarouselSection>
  );
};

export default HeroCarousel;
